<!-- How to use the component -->
<!-- <FormCheckbox
  :id="'ntf' + d.id"
  v-tooltip="{
    content: !d.read ? 'Mark as read' : false,
    trigger: isOnMobile ? 'click' : 'focus hover',
  }"
  class="ml-3 mr-n2 w-auto"
  :value="d.read"
  :label="''"
  :is-checked="d.read"
  :is-disabled="d.read"
  @cha
  nge="markNotificationAsRead(d.id)"
/> -->

<template>
  <label
    class="custom-checkbox-2"
    :for="id"
  >
    <input
      :id="id"
      v-model="localChecked"
      type="checkbox"
      :disabled="isDisabled"
      :name="name"
      :value="value"
      @change="onChange"
    >
    <span v-if="label">{{ label }}</span>
    <span class="checkmark" />
  </label>
</template>

<script>
export default {
  name: "FormCheckbox",

  props: {
    id: {
      type: String,
      required: true,
    },

    label: {
      type: String,
      required: true,
    },

    value: {
      type: [Boolean, String],
      required: false,
      default: "",
    },

    name: {
      type: String,
      required: false,
      default: "",
    },

    isChecked: {
      type: Boolean,
      required: false,
      default: false,
    },

    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      localChecked: this.isChecked,
    };
  },

  watch: {
    isChecked(newValue) {
      this.localChecked = newValue;
    },
  },

  methods: {
    onChange() {
      this.localChecked = !this.localChecked;
      this.$emit("change", this.localChecked);
    },
  },
};
</script>
